import React from 'react';
import { componentService } from 'js/services/component.service';

export const CasinoLeaderBoardList = React.lazy(() => import(/* webpackChunkName: "casino-leaderboard-list" */ './components/CasinoLeaderBoardList'));
export const CasinoLeaderBoardSlider = React.lazy(() => import(/* webpackChunkName: "casino-leaderboard-slider" */ './components/CasinoLeaderBoardSlider'));
export const CasinoLeaderBoardDetails = React.lazy(() => import(/* webpackChunkName: "casino-leaderboard-details" */ './components/CasinoLeaderBoardDetails'));
export const CasinoMysteryParcelDetails = React.lazy(() => import(/* webpackChunkName: "casino-leaderboard-details" */ './components/CasinoMysteryParcelDetails'));

componentService.registerPageComponents({ 'casino-races-list': CasinoLeaderBoardList });
componentService.registerPageComponents({ 'casino-leaderboardslider': CasinoLeaderBoardSlider });
componentService.registerPageComponents({ 'casino-leaderboard-page': CasinoLeaderBoardDetails });
componentService.registerPageComponents({ 'mystery-parcel-page': CasinoMysteryParcelDetails });
